var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-pane",attrs:{"role":"tabcard","id":"new-project"}},[_c('project-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }